/**
 * Ручной режим фото: режимы, форматы, черновые цены.
 *
 * ⚠️ Цены НЕ УТВЕРЖДЕНЫ владельцем (docs/economics.md, черновик). Меняются только здесь.
 */

export const PHOTO_MODES = ['fast', 'max'] as const;
export type PhotoMode = (typeof PHOTO_MODES)[number];

export const ASPECT_RATIOS = ['9:16', '1:1', '4:5', '16:9'] as const;
export type AspectRatio = (typeof ASPECT_RATIOS)[number];

export const MANUAL_PHOTO: Record<PhotoMode, { price: number; label: string; hint: string; etaSec: number }> = {
  fast: { price: 9, label: 'Быстро', hint: '≈ 15 секунд', etaSec: 15 },
  max: { price: 19, label: 'Максимум', hint: '4K, лучшая модель', etaSec: 40 },
};

/**
 * Ручной режим видео и песен — тоже ЧЕРНОВЫЕ цены, не утверждены.
 * Видео: Seedance 2.0, 5 с, 720p (себестоимость ≈ $0.29 ≈ 27 ₽). Песня: Suno V6, 2 варианта (≈ $0.06).
 */
export const MANUAL_VIDEO = { price: 69, durationSec: 5, resolution: '720p' as const, etaSec: 120, label: 'Видео 5 секунд' };
export const MANUAL_VIDEO_ASPECTS = ['9:16', '1:1', '16:9'] as const;
export type VideoAspect = (typeof MANUAL_VIDEO_ASPECTS)[number];
export const MANUAL_SONG = { price: 49, etaSec: 120, label: 'Песня · 2 варианта' };
/** Подсказки стилей в ручном режиме (можно вписать свой). */
export const SONG_STYLES = ['поп', 'рэп', 'рок', 'поп-панк', 'шансон', 'электроника', 'лоу-фай', 'акустика', 'детская'] as const;
export const SONG_STYLE_MAX = 120;
export const SONG_PROMPT_MAX = 1000;

/** Первая бесплатная генерация — только в этом режиме (себестоимость). */
export const FREE_GENERATION_MODE: PhotoMode = 'fast';

export const PROMPT_MAX_LENGTH = 2000;

/** Сколько храним результаты, дней. */
export const RESULTS_RETENTION_DAYS = 30;

/** Референс-фото: допустимые типы и размер. */
export const REFERENCE_MIME = ['image/jpeg', 'image/png', 'image/webp'] as const;
export const REFERENCE_MAX_BYTES = 10 * 1024 * 1024;
